import React from 'react';
import { View } from 'react-native';

import type { TabProps } from './tabs.types';
import { pt } from '../../style-utils';

export const Tab = ({ children }: TabProps) => (
  <View style={pt(16)}>{children}</View>
);

Tab.displayName = 'Tab';
